import React from 'react';
import { CTAButton } from './CTAButton';
import { ProductShot } from './ProductShot';
import { CHECKOUT_URL, lastQuestionKeeps, lastQuestionSteps } from '../data/content';
export function FinalCTA() {
  return <section className="border-t-4 border-mustard bg-navy px-4 py-7 text-center text-white sm:px-6" data-id="element-49" data-mp="c7tu3h83imsg">
      <p className="font-body text-[11px] font-extrabold uppercase tracking-[0.18em] text-mustard" data-id="element-50" data-mp="84e24y6z1am3">
        One last question
      </p>

      <p className="mx-auto mt-2 max-w-xl text-[13px] font-semibold leading-snug text-white/85 sm:text-sm" data-id="element-51" data-mp="m2voosl54h2f">
        How many times have you asked yourself:
      </p>
      <p className="mx-auto mt-1 max-w-xl font-heading text-lg font-extrabold italic leading-tight text-white sm:text-2xl" data-id="element-52" data-mp="vtgj03ts6zfj">
        “What activity are we going to do today?”
      </p>

      <p className="mt-3 text-[13px] font-bold text-white/80 sm:text-sm" data-id="element-53" data-mp="14whn5yz36ggk">
        Another week can pass.
      </p>

      <ul className="mx-auto mt-2 grid max-w-xl gap-1 text-left sm:grid-cols-2" data-id="element-54" data-mp="zxobmc3d0zj1">
        {lastQuestionKeeps.map(item => <li key={item} className="rounded bg-white/10 px-2.5 py-1 text-[12px] font-medium leading-snug text-white/75" data-id="element-55" data-mp="2c6rbsam3yip6">
            {item}
          </li>)}
      </ul>

      <p className="mt-3 font-heading text-base font-extrabold uppercase text-mustard sm:text-lg" data-id="element-56" data-mp="2m56ym1e3r5sv">
        Or you can open one organized system.
      </p>

      <ul className="mx-auto mt-2 flex max-w-xl flex-wrap justify-center gap-1" data-id="element-57" data-mp="2v2r5pqynbwbe">
        {lastQuestionSteps.map(step => <li key={step} className="rounded border border-mustard/50 px-2 py-0.5 text-[11px] font-bold text-white sm:text-xs" data-id="element-58" data-mp="300ivoffqd8cy">
            {step}
          </li>)}
      </ul>

      <ProductShot href={CHECKOUT_URL} size="sm" className="my-4" data-id="element-59" data-mp="3eri15hl9rgsb" />

      <p className="font-heading text-xl font-extrabold uppercase leading-none text-white sm:text-3xl" data-id="element-60" data-mp="3etcmuy4d7cxg">
        👥 Senior Activity Ready™
      </p>
      <p className="mt-1 text-[12px] font-extrabold uppercase tracking-wide text-mustard sm:text-sm" data-id="element-61" data-mp="1jntrdtdl5xxt">
        The complete ready-to-use activity system
      </p>
      <p className="mt-1 text-[11px] font-semibold uppercase tracking-wide text-white/70 sm:text-xs" data-id="element-62" data-mp="1en5r0h3gw4qx">
        Cognitive • Social • Creative • Recreational • Gentle Movement • Planning
      </p>

      <p className="mt-3 text-[12px] font-extrabold uppercase tracking-wide text-mustard" data-id="element-63" data-mp="1nonbscrtkuly">
        🔥 Get the complete system today
      </p>

      <div className="mx-auto mt-2 max-w-md" data-id="element-64" data-mp="1xg9m86wc2pnn">
        <CTAButton href={CHECKOUT_URL} tone="mustard" subLabel="Immediate Access • Digital Delivery" data-id="element-65" data-mp="1xfi1xs86seco">
          👥 Yes! I want Senior Activity Ready™
        </CTAButton>
      </div>

      <p className="mt-2.5 text-[12px] font-bold text-white sm:text-sm" data-id="element-66" data-mp="27c38ihzutxim">
        🛡️ 14-Day Money-Back Guarantee
      </p>
    </section>;
}